// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"982d8b8e","162":"54f5a395","404":"24958c3f","680":"d0482c35","983":"9c370a93"}[chunkId] + ".css";
};